import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderViewsComponent } from './header-views/header-views.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { SubSidebarComponent } from './sub-sidebar/sub-sidebar.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TabsComponent } from './tabs/tabs.component';
import { LoadingSpinnerComponent } from './loading-spinner/loading-spinner.component';
import { ModalConfirmationComponent } from './modal-confirmation/modal-confirmation.component';

@NgModule({
  declarations: [
    HeaderViewsComponent,
    SubSidebarComponent,
    LoadingSpinnerComponent,
    TabsComponent,
    ModalConfirmationComponent,
  ],
  imports: [
    CommonModule,
    MatTooltipModule,
    MatIconModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatIconModule,
  ],
  exports: [
    HeaderViewsComponent,
    SubSidebarComponent,
    LoadingSpinnerComponent,
    TabsComponent,
    ModalConfirmationComponent
  ],
})
export class CommonsModule {}
